'use strict';

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Map } from 'immutable';

import { showClaimForm } from '../../../app/Claims/actions';
import IconClaim from '../../Icons/IconClaim';

class ClaimFlatButton extends React.Component {
  constructor (props) {
    super(props);

    this.handleOpenForm = this.handleOpenForm.bind(this);
  }

  handleOpenForm (e) {
    const {realtyId, realtyType, dealType, eventOpenClaimForm} = this.props;

    eventOpenClaimForm();
    e.preventDefault();
    e.stopPropagation();

    const comment = new Map({
      realtyId,
      realtyType,
      dealType
    });

    this.props.dispatch(showClaimForm(comment));
  }

  render () {
    return <button
      onClick={this.handleOpenForm}
      data-tip data-for='tip-claim'
      className={'button ' + this.props.className}
    >
      <IconClaim />
      <span>&nbsp;Пожаловаться</span>
    </button>;
  }
}

ClaimFlatButton.propTypes = {
  realtyId: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]).isRequired,
  dealType: PropTypes.string.isRequired,
  realtyType: PropTypes.string.isRequired,
  dispatch: PropTypes.func.isRequired,
  className: PropTypes.string,

  eventOpenClaimForm: PropTypes.func
};

ClaimFlatButton.defaultProps = {
  className: '',
  eventOpenClaimForm: () => {}
};

export default connect()(ClaimFlatButton);



// WEBPACK FOOTER //
// ./src/ui/Controls/Claims/ClaimFlatButton.jsx